module.exports = __webpack_public_path__ + "static/media/armorySS.7bbd3c61.JPG";